const activeCompanies = state =>
  state.companies.filter(company => company.ativo)
export default {
  activeCompanies
}
